import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Lenis from 'lenis'

let lenis = null

// Smooth scroll for pointer users only; reduced-motion keeps native scrolling.
export function startSmoothScroll() {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return () => {}
  lenis = new Lenis({ lerp: 0.1 })
  let id = requestAnimationFrame(function raf(time) {
    lenis.raf(time)
    id = requestAnimationFrame(raf)
  })
  return () => {
    cancelAnimationFrame(id)
    lenis.destroy()
    lenis = null
  }
}

function scrollToId(id) {
  const el = document.getElementById(id)
  if (!el) return
  if (lenis) {
    // The page may have just mounted; Lenis would clamp to the old, shorter height.
    lenis.resize()
    lenis.scrollTo(el)
  } else el.scrollIntoView()
  el.focus({ preventScroll: true })
}

function scrollToTop() {
  if (lenis) lenis.scrollTo(0, { immediate: true })
  else window.scrollTo(0, 0)
}

// React Router doesn't scroll on navigation; handle `/#section` links and fresh pages.
export function useRouteScroll() {
  const { hash, key } = useLocation()
  useEffect(() => {
    if (hash) scrollToId(hash.slice(1))
    else scrollToTop()
  }, [hash, key])
}
